var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var Net = require('./net');

var Blockchain = require('./blockchain');

var Transaction = require('./transaction');
/**
 * RPC接口，用以发送交易和查询各类信息
 * @constructor
 * @param {HTTPProvider}provider - provider of this rpc
 */


var RPC =
/*#__PURE__*/
function () {
  "use strict";

  function RPC(provider) {
    _classCallCheck(this, RPC);

    this._provider = provider;
    this.net = new Net(this);
    this.blockchain = new Blockchain(this);
    this.transaction = new Transaction(this);
  }
  /**
   * 设置Provider
   * @param {HTTPProvider}provider - provider of this rpc
   */


  _createClass(RPC, [{
    key: "setProvider",
    value: function setProvider(provider) {
      this._provider = provider;
    }
    /**
     * 获取Provider
     * @returns {HTTPProvider}provider - provider of this rpc
     */

  }, {
    key: "getProvider",
    value: function getProvider() {
      return this._provider;
    }
  }]);

  return RPC;
}();

module.exports = RPC;